export default __webpack_public_path__ + "static/team-pic-c3e8b2285d250d5ee77f31c033071652.png";